import axios from "axios";
import React, { useEffect, useState } from "react";
import AssessmentTable from "../../AssesmentResults/Components/AssesmentTable";
import CreateAssessment from "../../AssesmentResults/Components/CreateAssesment";
import { API_URL } from "../../../url/api";

type AssessmentReportUploadProps = {
  doctorID: string | null;
};

export type AssessmentData = {
  id: number;
  assesment_report: string;
  assesment_date: string;
  name: string;
  is_assesment_submitted: boolean;
  assessment_pdf_url: string;
  updated_at: string;
  created_at: string;
  doctor: number;
  session: number;
  user: number;
};

const AssessmentReportUpload: React.FC<AssessmentReportUploadProps> = ({
  doctorID,
}) => {
  const [assessmentData, setAssementData] = useState<AssessmentData[]>([]);
  const [addReport, setAddReport] = useState(false);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await axios.get<AssessmentData[]>(
        `${API_URL}assessment/?doctor=${doctorID}`
      );
      console.log("🚀 ~ fetchData ~ doctorID:", response);
      setAssementData(response.data);
    } catch (error) {
      console.error("Error fetching appointment data:", error);
    }
  };

  const onDeleteReport = async (id: number) => {
    let yes = window.confirm("Are you sure you want to delete this report?");
    if (yes) {
      const response = await axios.delete<AssessmentData[]>(
        `${API_URL}assessment/${id}/`
      );
      console.log("🚀 ~ fetchData ~ doctorID:", response);
      fetchData();
    }
  }

  function onCreated(): void {
    setAddReport(false);
    fetchData();
  }

  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-xl ">All appointments</h3>
        <button
          onClick={() => setAddReport(true)}
          className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          Add Report
        </button>
      </div>

      {!assessmentData.length && (
        <div className="text-center text-sm pt-10 opacity-50">
          No assessment reports found
        </div>
      )}

      {assessmentData.length > 0 && (
        <div className="overflow-x-auto">
        <AssessmentTable assessmentData={assessmentData} deleteReport={onDeleteReport} />
        </div>
      )}

      {doctorID && (
        <CreateAssessment
          doctorID={doctorID}
          showPopup={addReport}
          onClose={() => setAddReport(false)}
          onCreated={onCreated}
        />
      )}
    </div>
  );
};

export default AssessmentReportUpload;
